<div class="component-container">
     <div class="container">
        <!-- Header -->
        <div class="header">
            <div>
                <h1>Instance Management</h1>
                <p>Manage your cloud instances and infrastructure</p>
            </div>
            <button id="createInstanceBtn" class="btn" (click)="showModal()" [disabled]="page.totalItems > 1">
                <svg class="stat-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                Create Instance
            </button>
        </div>
    

        <!-- Stats Cards -->
        <div class="stats-grid">
            <div class="stat-card">
                <div class="stat-content">
                    <svg class="stat-icon blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"></path>
                    </svg>
                    <div class="stat-info">
                        <h3>Total Instances</h3>
                        <p id="totalInstances">{{ page?.totalItems || 0 }}</p>
                    </div>
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-content">
                    <svg class="stat-icon green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                    </svg>
                    <div class="stat-info">
                        <h3>Running</h3>
                        <p id="runningInstances">{{ activeInstance || 'none' }}</p>
                    </div>
                </div>
            </div>
     
        </div>

        <!-- Instances Table -->
        <div class="card">
            <div class="card-header">
                <h2>Instances</h2>
                <p>Manage and monitor your cloud infrastructure</p>
            </div>
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Instance</th>
                            <th>Status</th>
                            <th style="text-align: right;">Actions</th>
                        </tr>
                    </thead>
                    <tbody id="instancesTableBody">
                        <!-- Instances will be populated by JavaScript -->
                           <tr *ngFor="let instance of page.data; let i = index;">
                    <td>
                        <div class="instance-info">
                            <span class="instance-icon">{{typeIcons[instance.type]}}</span>
                            <div class="instance-details">
                                <h4>{{instance?.name}}</h4>
                                <p>hjhjkhkjhk</p>
                            </div>
                        </div>
                    </td>
                    <td>
                        <span class="status-badge status-${instance.status.toLowerCase()}">
                            {{instance.status}}
                        </span>
                    </td>
                  
                    <td style="text-align: right;">
                        <div class="dropdown-container">
                            <button class="dropdown-trigger" (click)="toggleDropdown(instance.id)">
                                <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path>
                                </svg>
                            </button>
                            <div id="dropdown-{{instance.id}}" class="dropdown" [ngClass]="{'show': instance.id === selectedInstance }">
                                
                                    <button class="dropdown-item success" (click)="handleInstanceAction(i, 'start')" *ngIf="instance.status === 'stopped' || !instance.status">
                                        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h1m4 0h1m6-6V7a3 3 0 00-3-3H6a3 3 0 00-3 3v4a3 3 0 003 3h7a3 3 0 003-3z"></path>
                                        </svg>
                                        Start
                                    </button>
                            
                                    <button class="dropdown-item warning" (click)="handleInstanceAction(i, 'stop')" *ngIf="instance.status === 'running'">
                                        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"></path>
                                        </svg>
                                        Stop
                                    </button>
                                    <button class="dropdown-item info" (click)="handleInstanceAction(i, 'restart')" *ngIf="instance.status === 'running'">
                                        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                                        </svg>
                                        Restart
                                    </button>
                                
                                <button class="dropdown-item danger" (click)="handleInstanceAction(i, 'delete')" >
                                    <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                    </svg>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- Create Instance Modal -->
    <div id="createModal" class="modal" [ngClass]="{'show': modal}">
        <div class="modal-content">
            <div class="modal-header">
                <h2>Create New Instance</h2>
                <p>Deploy a new instance with your preferred configuration.</p>
            </div>
            <form id="createInstanceForm">
                <div class="form-group">
                    <label for="instanceName" class="form-label">Instance Name</label>
                    <input type="text" name="instanceName" class="form-input" placeholder="my-instance" [(ngModel)]="modalInstance.name">
                </div>
     
                <div class="modal-footer">
                    <button type="button" id="cancelCreate" class="btn btn-outline" (click)="hideModal()">Cancel</button>
                    <button type="submit" class="btn" (click)="addInstance()">Create Instance</button>
                </div>
            </form>
        </div>
    </div>

    <!-- Toast Notification -->
    <div id="toast" class="toast" [ngClass]="{'show': toast}">
        <h4 id="toastTitle">{{ toastTitle }}</h4>
        <p id="toastMessage">{{ toastMessage }}</p>
    </div>
</div>